import { observable, makeObservable } from 'mobx'

class DataTableStore {
    @observable rowLimit = {
        value: 20,
        label: 20,
    }

    rowCounts = [
        {
            value: 5,
            label: 5,
        },
        {
            value: 10,
            label: 10,
        },
        {
            value: 20,
            label: 20,
        },
        {
            value: 50,
            label: 50,
        },
    ]

    @observable firstPage = 1

    @observable pageCount = 0

    @observable dataLength = 0

    @observable maxRecord = 0

    @observable page = 1

    @observable minRecord = 0

    pageLimit = 10

    @observable records = ''

    constructor(dataLength, loadRecords) {
        makeObservable(this)
        if (typeof loadRecords === 'function') {
            this.loadDataRows = loadRecords
            this.init()
        } else {
            this.dataLength = dataLength
            this.pageCount = Math.ceil(this.dataLength / this.rowLimit.value)
            this.minRecord = 0
            this.maxRecord = (this.page * this.rowLimit.value) - 1
            const first = dataLength > 0 ? 1 : 0
            const m = dataLength <= this.maxRecord ? dataLength : this.maxRecord + 1
            this.records = `${first} to ${m}`
        }
    }

    init = async () => {
        const dataLength = await this.loadRecords()
        this.dataLength = dataLength
        this.pageCount = Math.ceil(this.dataLength / this.rowLimit.value)
        this.minRecord = 0
        this.maxRecord = (this.page * this.rowLimit.value) - 1
        const first = dataLength > 0 ? 1 : 0
        const m = dataLength <= this.maxRecord ? dataLength : this.maxRecord + 1
        this.records = `${first} to ${m}`
    }

    loadRecords = async () => {
        const from = (this.page - 1) * this.rowLimit.value
        const top = this.rowLimit.value

        const resp = await this.loadDataRows(from, top)
        this.dataRows = resp.rows
        this.records = `${(from + 1)} to ${(Math.min(resp.numRows, top * this.page))}`

        return resp.numRows
    }

    updateDataLength = (dataLength) => {
        this.dataLength = dataLength
        this.pageCount = Math.ceil(this.dataLength / this.rowLimit.value)
        this.firstPage = 1
        this.page = this.firstPage
        this.minRecord = 0
        this.maxRecord = (this.page * this.rowLimit.value) - 1
        const first = dataLength > 0 ? 1 : 0
        const m = dataLength <= this.maxRecord ? dataLength : this.maxRecord + 1
        this.records = `${first} to ${m}`
        if (this.loadDataRows) {
            this.loadRecords()
        }
    }

    changeRowLimit = (rowLimit) => {
        this.rowLimit = rowLimit
        this.pageCount = Math.ceil(this.dataLength / this.rowLimit.value)
        this.firstPage = 1
        this.page = this.firstPage
        this.minRecord = 0
        this.maxRecord = (this.page * this.rowLimit.value) - 1
        const first = this.minRecord + 1
        const m = this.dataLength < this.maxRecord ? this.dataLength : this.maxRecord + 1
        this.records = `${first} to ${m}`

        if (this.loadDataRows) {
            this.loadRecords()
        }
    }

    changePage = (pageIndex) => {
        this.page = pageIndex
        if (pageIndex === 1) {
            this.firstPage = 1
        }
        if (pageIndex >= (this.firstPage + this.pageLimit)) {
            this.firstPage += this.pageLimit
        } else if (pageIndex < this.firstPage) {
            this.firstPage -= this.pageLimit
        }

        if (this.loadDataRows) {
            this.loadRecords()
        } else {
            this.minRecord = (this.page - 1) * this.rowLimit.value
            this.maxRecord = (this.page * this.rowLimit.value) - 1
            const first = this.minRecord + 1
            const m = this.dataLength < this.maxRecord ? this.dataLength : this.maxRecord + 1
            this.records = `${first} to ${m}`
        }
    }

    nextPages = () => {
        this.firstPage += this.pageLimit
        this.page = this.firstPage
        this.minRecord = (this.page - 1) * this.rowLimit.value
        this.maxRecord = (this.page * this.rowLimit.value) - 1
        const first = this.minRecord + 1
        const m = this.dataLength < this.maxRecord ? this.dataLength : this.maxRecord + 1
        this.records = `${first} to ${m}`
    }

    prevPages = () => {
        this.firstPage -= this.pageLimit
        this.page = this.firstPage
        this.minRecord = (this.page - 1) * this.rowLimit.value
        this.maxRecord = (this.page * this.rowLimit.value) - 1
        const first = this.minRecord + 1
        const m = this.dataLength < this.maxRecord ? this.dataLength : this.maxRecord + 1
        this.records = `${first} to ${m}`
    }
}

export default DataTableStore
